import createStore from "@Stores/base-factories";
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection";

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory("audit-log")
  .extendHookCollectionsFactory("audit-logs")
  .factory()

export {
  Provider as ChangeHistoryProvider,
  useStore as useChangeHistory,
}
